

import { pricingData } from "@/config/subscriptions";
import * as m from "@/paraglide/messages";
import { axiosInstance } from "@/services/api/axiosConfig";
import { UserSubscriptionPlan } from "@/types";

export async function getUserSubscriptionPlan({
  controller,
}: {
  controller?: AbortController;
}): Promise<UserSubscriptionPlan> {
  const { data } = await axiosInstance.get(
    "/subscription/status",
    {
      signal: controller?.signal ?? undefined,
    },
  );

  if (data.error_code != null) {
    throw data.message;
  }

  const subscription = data.data;

  if (!subscription) {
    throw new Error("Subscription not found");
  }

  // Check if user is on a paid plan.
  const isPaid =
    (subscription.stripe_price_id &&
      new Date(subscription.subscription_expiry)?.getTime() + 86_400_000 >
      Date.now()) ||
      (subscription.subscription_duration_days &&
        new Date(subscription.subscription_expiry)?.getTime() + 86_400_000 >
        Date.now())
      ? true
      : false;

  // Find the pricing data corresponding to the user's plan
  const userPlan =
    isPaid && subscription.subscription_duration_days !== 0
      ? pricingData(m)[1]
      : pricingData(m).find(
        (plan) => plan.stripeIds.monthly === subscription.stripe_price_id,
      ) ||
      pricingData(m).find(
        (plan) => plan.stripeIds.yearly === subscription.stripe_price_id,
      );

  const plan = isPaid && userPlan ? userPlan : pricingData(m)[0];

  const interval = isPaid
    ? userPlan?.stripeIds.monthly === subscription.stripe_price_id
      ? "month"
      : userPlan?.stripeIds.yearly === subscription.stripe_price_id
        ? "year"
        : null
    : null;

  let isCanceled = subscription.subscription_status === -2;

  return {
    ...plan,
    ...subscription,
    stripeCurrentPeriodEnd: new Date(
      subscription.subscription_expiry,
    )?.getTime(),
    isPaid,
    interval,
    isCanceled,
  };
}
